import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import shouldFlipText from "./shouldFlipText";
import { getComplementSequenceString } from "@teselagen/sequence-utils";
import { getDnaColor } from "../constants/dnaToColor";
export function CircularDnaSequence({
  rotationRadians,
  textHeightOffset = -5,
  annotation,
  showReverseSequence,
  showDnaColors,
  showSeqText,
  totalAngle,
  radius
}) {
  const shouldFlip = shouldFlipText(annotation.startAngle + rotationRadians);
  const getShared = ({ textHeightOffset: textHeightOffset2, isReverse }) => ({
    className: `ve-monospace-font ${isReverse ? "ve-sequence-reverse" : ""}`,
    transform: (shouldFlip ? "rotate(180)" : "") + ` translate(0, ${shouldFlip ? -textHeightOffset2 : textHeightOffset2})`,
    style: {
      fontSize: 12,
      textAnchor: "middle",
      dominantBaseline: "central"
    }
  });
  let forward = null;
  let reverse = null;
  let dnaColors = null;
  if (showSeqText) {
    forward = /* @__PURE__ */ jsx(
      "text",
      {
        ...getShared({
          textHeightOffset: showReverseSequence ? textHeightOffset - 15 : textHeightOffset
        }),
        children: annotation.letter
      }
    );
  }
  if (showSeqText && showReverseSequence) {
    reverse = /* @__PURE__ */ jsx("text", { ...getShared({ textHeightOffset, isReverse: true }), children: getComplementSequenceString(annotation.letter) });
  }
  if (!showSeqText || showDnaColors) {
    const height = showReverseSequence ? 30 : 15;
    const width = Math.max(0, totalAngle * radius);
    dnaColors = /* @__PURE__ */ jsx(
      "rect",
      {
        fill: getDnaColor(annotation.letter),
        height,
        width,
        transform: `translate(-${width / 2}, -${height - 3})`,
        className: "veDnaColor"
      }
    );
  }
  return /* @__PURE__ */ jsxs("g", { children: [
    dnaColors,
    forward,
    reverse
  ] });
}
